<div class="body">
  <div class="container">
    <div class="row title-box">
      <div class="col-12 col-sm-12">
        <h3 class="txtbienvenida">Parametrización <span class="txtbienvenida-2">de líneas</span></h3>
      </div>
    </div>
    <div class="row justify-content-end">
      <div class="col-12 col-sm-2 container-btn">
        <button type="button" [routerLink]="['crear']" style="width: 180px;" class="btn btn-primary hvr-shrink">
          Crear Línea
        </button>
      </div>
    </div>
    <div class="row  pr-3 pl-3">
      <div class="table-responsive">
        <table class="table table-striped table-borderless rounded">
          <thead class="table_head">
            <tr>
              <th scope="col" class="no-styles table-header" id="date-rango">
                Nombre Línea
              </th>
              <th scope="col" class="no-styles table-header" id="date-rango">
                Descripción Línea
              </th>
              <th scope="col" class="no-styles table-header" id="date-rec">
                Fecha de registro
              </th>
              <th scope="col" class="no-styles table-header" id="solicitante">
                Estado Línea
              </th>
              <th scope="col" class="no-styles table-header" id="doc">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody>
            @for (lc of lineasCredito | async; track lc) {
              <tr>
                <th scope="row" id="id-monto">{{ lc.nombreLinea | uppercase }}</th>
                <td>{{ lc.nombre }}</td>
                <td>{{ lc.fechaRegistro|date: "dd/MM/yyyy, h:mm a" }}</td>
                <td>{{ lc.estado | uppercase }}</td>
                <td>
                  <button type="button" [routerLink]="['crear',lc.idParametrizacionLinea]" id="btn-editar"
                    data-bs-toggle="modal" data-bs-target="#editModal" class="hvr-shrink"
                    data-bs-toggle="tooltip" data-bs-placement="top" title="Editar">
                    <i class="fas fa-pencil-alt"></i>
                  </button>
                  <button type="button" id="btn-borrar"
                    (click)="deleteLineaDeCredito(lc.idParametrizacionLinea)" class="hvr-shrink"
                    data-bs-toggle="tooltip" data-bs-placement="top" title="Eliminar">
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    <div class="row justify-content-center mt-3">
      <div class="col-12 col-md-4 container-btn ">
        <button class="btn btn-primary hvr-shrink" style="width: 180px;" routerLink="/intermediario/home">
          Volver
        </button>
      </div>
    </div>
  </div>
  <div class="footer-body"></div>
</div>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
